import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { library } from '@fortawesome/fontawesome-svg-core'

import HeaderText from '../../components/personal/HeaderText';
import SetTitle from '../../components/personal/SetTitle';
import DestinationSwitch from '../../components/shared/DestinationSwitch';

import { formatDate, generateId, debounce, scrollElementToTop } from '../../utilities/generic/Common.js'

import { handleRadio, getAnonymousQuestionIds, renderQuestion, anonymousMessage, handleFeedbackChange, handleMultiSelectCheckbox, compileAnswers } from '../../utilities/generic/Forms.js'

library.add(fas, far)

class Feedback extends Component {

  constructor(props) {
    super(props);

    this.debouncedScrollElementToTop = debounce(scrollElementToTop, 1000);
    this.handleFeedbackChange = handleFeedbackChange.bind(this);
    this.handleMultiSelectCheckbox = handleMultiSelectCheckbox.bind(this);
    this.handleRadio = handleRadio.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.compileAnswers = compileAnswers.bind(this);
  }

  state = {
    answers: {},

    errors: "",
    error: ""
  }

  handleSubmit(event) {
    let anonymousQuestionIds = getAnonymousQuestionIds(this)

    let token = this.props.location.state.token

    var headers = new Headers();
    headers.append("Content-Type", "application/json");

    var json = null

    var answersWithAppIds = {}

    for (const key in this.state.answers) {
      answersWithAppIds[generateId()] = {
        question_id: key,
        answer: this.compileAnswers(key)
      }
    }

    if (this.props.location.state.direction === "arriving") {
      json = JSON.stringify({
        "personal": {
          "token": token,
          "arriving_app_id": this.props.location.state.directional_app_id,
          "answers": answersWithAppIds,
          "anonymous_question_ids": anonymousQuestionIds,
          "app_id": generateId(),
          "version": process.env.REACT_APP_COMMIT_HASH,
          "created_at": formatDate(new Date()),
          "profile_id": this.props.location.state.profile.id,
          "type_of_person": this.props.location.state.profile.type_of_person
        }
      })
    }
    else {
      json = JSON.stringify({
        "personal": {
          "token": token,
          "leaving_app_id": this.props.location.state.directional_app_id,
          "answers": answersWithAppIds,
          "anonymous_question_ids": anonymousQuestionIds,
          "app_id": generateId(),
          "version": process.env.REACT_APP_COMMIT_HASH,
          "created_at": formatDate(new Date()),
          "profile_id": this.props.location.state.profile.id,
          "type_of_person": this.props.location.state.profile.type_of_person
        }
      })
    }

    var requestOptions = {
      method: 'POST',
      headers: headers,
      body: json,
      redirect: 'follow'
    };

    var errorsInResponse = false

    fetch(`${process.env.REACT_APP_ROOT_DOMAIN}/v1/d/personal/feedback`, requestOptions)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      else if (response.status === 401 || response.status === 422) {
        errorsInResponse = true
        return response.json()
      }
      else {
        throw new Error('Something went wrong ...');
      }
    })
    .then(data => {
      if (errorsInResponse) {
        this.setState({ errors: data })
      } else {
        this.setState({ updated: true, errors: ""})
      }
    })
    .catch(error => this.setState({ error, loaded: true }))

    event.preventDefault();
  }

  render() {
    if (this.props.location.state === undefined) {
      return <Redirect to="/personal/404" />
    }

    let profile = this.props.location.state.profile
    let direction = this.props.location.state.direction

    const { updated, errors, error } = this.state;

    if (updated) {
      return <DestinationSwitch current_page="feedback" profile={profile} direction={direction} personal={true} />
    }

    if (errors) {
      return (
        <div className="errors">
          Sorry, looks like you have some errors:
          <ul>
            {errors.errors.map((error) => (
              <li>{error}</li>
            ))}
          </ul>
        </div>
      )
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    let feedbackTypes = this.props.location.state.feedbackTypes

    return (
      <div className="main-page feedback-page">
        <SetTitle title={"Feedback"} profile={profile} />
        <HeaderText message={profile.welcome_message} />

        <div className="content">

          <div className="feedback">
            <form autoComplete="off" onSubmit={this.handleSubmit}>
              {feedbackTypes.map((feedback) => {
                const top_level_feedback_questions = feedback.feedback_questions.filter(feedback_question => !feedback_question.depends_on_question_id)

                if (top_level_feedback_questions.length !== 0) {
                  return (
                    <div className="feedback-type" key={feedback.id}>
                      { anonymousMessage(feedback.anonymous) }

                      <div className="feedback-title">{feedback.display}</div>

                      {top_level_feedback_questions.map(question =>
                        renderQuestion(question, feedback, this)
                      )}
                    </div>
                  )
                }
                else {
                  return(null)
                }
              })}

              <div className="submit-container">
                <input type="submit" value="Submit" />
              </div>
            </form>
          </div>

        </div>
      </div>
    );
  }
}

export default Feedback;
